import { tagCommanderReload, tagCommanderSetVariables } from '@declaration/helpers/tagCommander';
function routerMiddleware(context) {
    var _a;
    if (((_a = context.route.meta) === null || _a === void 0 ? void 0 : _a.length) && context.route.meta[0].tcVars) {
        tagCommanderSetVariables(context.route.meta[0].tcVars);
        tagCommanderReload();
    }
}
export default routerMiddleware;
